import { Assessment } from '@playbooks/core/src/interfaces/ActionCard'

import { BaseNode, ResponseNode } from '../../../actionCard'

export class AssessmentNode extends BaseNode {
  declare data: Assessment

  public getLabelTemplate(): string {
    return this.data.question
  }

  public get IInputNode(): boolean {
    return true
  }

  public stringifyValue(): string {
    const value = this.__getValue()

    if (!value.ids) {
      return ''
    }

    const responsesAnswers: string[] = []
    for (const response of getResponseNodes.call(this)) {
      if (value.ids.includes(response.getId())) {
        responsesAnswers.push(response.getLabel())
      }
    }

    return `${responsesAnswers.join('; ')}${value.text ? ': ' : ''}${value.text}`
  }

  public isInputEmpty(): boolean {
    const value = this.__getValue()
    return !value.ids.length
  }

  protected __setValue({ ids, text }: { ids: number[]; text: string }): void {
    if (!this.data.checked) {
      return
    }
    for (const responseNode of getResponseNodes.call(this)) {
      const isChecked = ids.includes(responseNode.getId()) ?? false
      responseNode.setIsChecked(isChecked)
    }
    setFreeText.call(this, text)
  }

  protected __getValue(): { ids: number[]; text: string } {
    if (!this.data.checked) {
      return {
        ids: [],
        text: '',
      }
    }

    const ids = getResponseNodes
      .call(this)
      .filter(x => x?.getIsChecked())
      .map(x => x.getId())

    const text = getFreeText.call(this)

    return {
      ids: ids.length > 0 ? ids : [],
      text: text ?? '',
    }
  }
}

function getResponseNodes(this: AssessmentNode): ResponseNode[] {
  if (!this.children) {
    return []
  }
  return this.children as ResponseNode[]
}

function getFreeText(this: AssessmentNode): string {
  return isFreeTextAvailable.call(this) ? (this.data.freeTextValue ?? '') : ''
}

function setFreeText(this: AssessmentNode, freeText: string): void {
  this.data.freeTextValue = isFreeTextAvailable.call(this) ? freeText : ''
}

function isFreeTextAvailable(this: AssessmentNode): boolean {
  return (this.data.hasFreeText ?? false) && (getLastResponse.call(this)?.getIsChecked() ?? false)
}

function getLastResponse(this: AssessmentNode): ResponseNode | null | undefined {
  if (this.children.length <= 0) {
    return
  }
  return this.children[this.children.length - 1] as ResponseNode
}
